
(function() {
var c = document.createElement('script');
c.setAttribute('type', 'text/javascript');
c.setAttribute('async', true);
c.setAttribute('src', ('https:' == location.protocol ? 'https://' : 'http://') + 'captcha.luosimao.com/static/dist/captcha.js?v=201610101436');
var x = document.getElementsByTagName('script')[0];
x.parentNode.insertBefore(c, x);
})()

import $ from 'webpack-zepto'
import {
mapState,
mapGetters,
mapActions
} from 'vuex'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

import {
get,
post,
isAndroid,
isWeiXin
} from '../../util'
import * as types from '../../vuex/types'

export default {
components: {
Tabbar,
TabbarItem
},
data() {
return {
documentWidth: 0,
tips: '',
showTips: false,
isSending: false,
sendLabel: '获取短信',
isBinding: false,
bindLabel: '<i class="iconfont icon-complete"></i> 提交绑定',
bindParam: {
mobile: '',
code: '',
}
}
},
computed: {
...mapState({
needBind: state => state.common.needBind,
navs: state => state.common.tabButtons,
curTab: state => state.common.curTab,
cartsNum: state => state.carts.cartsNum
})
},
methods: {
sendSMS(e) {
var _this = this;
if (!_this.isSending) {

if (!(/^1[3|4|5|7|8|9][0-9]\d{4,8}$/.test(_this.bindParam.mobile))) {
_this.showTip('手机号不合法')
return false
}






_this.isSending = true;
_this.sendLabel = '发送中...';
post('v1/member/send_sms', {
mobile: _this.bindParam.mobile,

}, function(rsp) {
if (rsp.body.code != 10000) {
_this.showTip(rsp.body.msg)
_this.sendLabel = '获取短信'
_this.isSending = false;
LUOCAPTCHA.reset()
} else {
var seconds = 60;
var s = setInterval(function() {
if (seconds > 0) {
seconds--
_this.sendLabel = seconds + 's后重发'
} else {
_this.sendLabel = '获取短信'
_this.isSending = false;
clearInterval(s)
}
}, 1000);
}
})
}
},
showTip(tip) {
var _this = this
_this.showTips = true
_this.tips = tip
setTimeout(function() {
_this.showTips = false
_this.tips = ''
}, 3000)
},
bindUser() {
var _this = this
if (!(/^1[3|4|5|7|8|9][0-9]\d{4,8}$/.test(_this.bindParam.mobile))) {
_this.showTip('手机号不合法')
return false
}
if (_this.bindParam.code == '') {
_this.showTip('请输入短信验证码')
return false
}

var avatar = localStorage.getItem('avatar')
var nickname = localStorage.getItem('nickname')
var open_id = localStorage.getItem('open_id')
var union_id = localStorage.getItem('union_id')

if (open_id.length > 0 && union_id.length > 0) {
_this.isBinding = true
_this.bindLabel = '<i class="iconfont icon-loading spin"></i> 绑定中'
post('v1/member/bind_mobile', {
mobile: _this.bindParam.mobile,
code: _this.bindParam.code,
nickname: nickname,
avatar: avatar,
union_id: union_id,
open_id: open_id
}, function(rsp) {
_this.isBinding = false
_this.bindLabel = '<i class="iconfont icon-complete"></i> 提交绑定'
if (rsp.body.code == 10000) {

localStorage.removeItem(avatar)
localStorage.removeItem(nickname)
localStorage.removeItem(open_id)
localStorage.removeItem(union_id)

localStorage.setItem("RS-TOKEN", rsp.body.data.token)

let href = localStorage.getItem('refHref')
href = (href != undefined) ? href : '/'

localStorage.removeItem('refHref')
window.location.href = href
} else {
_this.showTip(rsp.body.msg)
}
})
} else {

window.location.href = '/'
return false
}
},
getCartsNum() {
let _this = this
get('/v1/cart/get_carts_num', {}, function(rsp) {
let res = rsp.body
if (res.code == 10000) {
_this.$store.commit(types.UPDATE_CARTS_NUM, {
type: 1,
num: parseInt(res.data)
})
}
})
},
getFocus(type, event) {
let target = event.target,
index = $(target).parents('.form-control').index()


if (type == 1) {
if (isAndroid() && isWeiXin()) {
$('.bind-form').css({
'height': (index == 2) ? '100%' : '140%',
'top': (index == 2) ? '-10%' : '-40%'
})
}
} else {
$('.bind-form').css({
'height': '70%',
'top': '10%',
})
}
},
...mapActions([
'changeCurTab'
]),
},
mounted() {
this.getCartsNum()
}
}



// WEBPACK FOOTER //
// ./src/components/home/rs_bottom.vue